import App from './components/app';
import './style';

export default App;



// WEBPACK FOOTER //
// ./index.js